import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex-brightworld/icons';
import LocationFinder from '../LocationFinder/LocationFinder';

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;

  @media ${({ theme }) => theme.breakpoints.tabletMin} {
    flex-direction: row;
    padding: 20px;
  }

  background-color: #542376;
  background-image: linear-gradient(to bottom, #2b2b79, #7e1b72);
  color: white;
  padding: 10px;
`;

const StyledLocationFinder = styled(LocationFinder)`
  margin: auto;
  width: 100%;
  & [class^='Input__InteractivePlaceholder'] {
    background-color: ${({ theme }) => theme.colors.shades[7]} !important;
    border-radius: 2px;
  }
  @media ${({ theme }) => theme.breakpoints.tabletMin} {
    max-width: 320px;
  }
`;

const InnerWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;

  @media ${({ theme }) => theme.breakpoints.tabletMin} {
    margin-bottom: 0;
    width: 50%;
  }
`;

const LocationIcon = styled(Icon)`
  & svg {
    height: 100%;
    width: 100%;
  }
  color: transparent;
  stroke: white;
  stroke-width: 1.5;
  text-align: right;
  @media ${({ theme }) => theme.breakpoints.tabletMin} {
    height: 130%;
  }
`;

const Title = styled.div`
  font-size: 22px;
  font-weight: bold;
`;

const Text = styled.div`
  display: none;
  @media ${({ theme }) => theme.breakpoints.tabletMin} {
    display: block;
    font-size: 16px;
    font-weight: 300;
  }
`;

const ContentWrapper = styled.div`
  margin: 0 10px;
`;

const StoreLocator = ({ title, text, ...rest }) => (
  <OuterWrapper>
    <InnerWrapper>
      <LocationIcon icon="location" size="large" />
      <ContentWrapper>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </ContentWrapper>
    </InnerWrapper>
    <InnerWrapper>
      <StyledLocationFinder {...rest} />
    </InnerWrapper>
  </OuterWrapper>
);

StoreLocator.propTypes = {
  className: PropTypes.string,
  placeholderText: PropTypes.string,
  useMyLocationText: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  /**
   * when place was selected
   * @param {Place} place
   * { name: string, area: string, placeResult: google.maps.places.PlaceResult }
   */
  onChange: PropTypes.func,

  /**
   * when geolocation was used
   * @param {Position} position
   */
  onLocate: PropTypes.func,

  /**
   * show loading indicator (if you need to do something after the change)
   */
  busy: PropTypes.bool,

  qa: PropTypes.string
};

StoreLocator.defaultProps = {
  className: undefined,
  title: undefined,
  text: undefined,
  placeholderText: 'Enter town or postcode',
  useMyLocationText: 'Use my location',
  onChange: () => {},
  onLocate: () => {},
  busy: false,
  qa: undefined
};

export default StoreLocator;
